import React, { useState } from 'react';
import UserInputForm from './UserInputForm';
import PatientForm from './PatientForm';

import './userMainMenu.css';

const UserMainMenu = () => {
  const [patientData, setPatientData] = useState(null);

  return (
    <div className="userMainMenu-container">
      <h1>User Main Menu</h1>
      <h3>Please input the specified parameters</h3>
      {patientData ? (
        <UserInputForm patientData={patientData} />
      ) : (
        <PatientForm setPatientData={setPatientData} />
      )}
    </div>
  );
};

export default UserMainMenu;
